// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    purchaseList: [],
    totalRows: 0,
    rowsPerPage: 5,
    page: 0,
    selectedPurchase: null,
    message: null,
    status: false,
    error: ''
};

const slice = createSlice({
    name: 'purchase',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },
        setPurchases(state, action) {
            state.purchaseList = action.payload;
        },
        setPurchaseRowPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        setPurchasePage(state, action) {
            state.page = action.payload;
        },
        setTotalRows(state, action) {
            state.totalRows = action.payload;
        },
        setSelectedPurchase(state, action) {
            state.selectedPurchase = action.payload;
        },
        setPurchase(state, action) {
            const data = action.payload;
            const rowIndex = state.purchaseList.findIndex((item) => item.id === data.id);
            if (rowIndex) {
                state.purchaseList[rowIndex] = data;
            }
        }
    }
});

// Reducer
export default slice.reducer;
export const { setSelectedPurchase, setPurchaseRowPerPage, setPurchasePage } = slice.actions;
// ----------------------------------------------------------------------

export function getPurchases(data) {
    return async () => {
        try {
            const response = await axios.post('/purchase/list', data);
            if (response.data.status) {
                dispatch(slice.actions.setPurchases(response.data.data));
                dispatch(slice.actions.setTotalRows(response.data.total_rows));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error.message));
        }
    };
}
export function getPurchase(id) {
    return async () => {
        try {
            const response = await axios.post('/purchase/details', { id });
            if (response.data.status) {
                dispatch(slice.actions.setPurchase(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            console.log(error);
        }
    };
}
export function savePurchase(data) {
    return async function () {
        const response = await axios.post('purchase/save', data);
        return response;
    };
}

export function updatePurchase(data) {
    return async function () {
        const response = await axios.post('purchase/update', data);
        return response;
    };
}

export function deletePurchase(data) {
    return async function () {
        const response = await axios.post('purchase/delete', data);
        return response;
    };
}
